export default {
  heading: 'Abril Fatface, cursive',
  body: 'Playfair Display, serif',
  monospace: 'Menlo, monospace',
  display: 'Abril Fatface, cursive',
  googleFonts: ['Abril Fatface', 'Playfair Display']
  // customFamilies: ['', ''],
  // customUrls: ['', ''],
}
